import { render, staticRenderFns } from "./OrganizStudentRequest.vue?vue&type=template&id=1a73cd42&scoped=true&"
import script from "./OrganizStudentRequest.vue?vue&type=script&scoped=true&lang=js&"
export * from "./OrganizStudentRequest.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./OrganizStudentRequest.vue?vue&type=style&index=0&id=1a73cd42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a73cd42",
  null
  
)

export default component.exports